import React from "react";
import { withTranslation } from "react-i18next";
import submit from "submit-form";
import Modal from "../modal-new";
import { validateWidget } from "../../utils/widgets";
import ImageRadio from "../inputs/image-radio";
import { WIDGET_ICONS, WIDGET_TYPES } from "../../constants";
import RadioGroupDropdown from "../inputs/radio-group-dropdown";
import { RillContext } from "../../rill/RillReact/share/base";

class CreateWidgetModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      form: {
        name: "",
        description: "",
        type: props.type || "recipe",
        icon:
          (WIDGET_ICONS[props.type] && WIDGET_ICONS[props.type][0]) ||
          "utensils",
      },
      submitted: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.ableToSubmit = this.ableToSubmit.bind(this);
  }

  handleChange(e) {
    const { name, value } = e.target;
    const { form } = this.state;

    const formCopy = Object.assign({}, form, { [name]: value });

    this.setState({ form: formCopy });
  }

  handleSubmit(e) {
    e.preventDefault();

    const { submitted, form } = this.state;
    const { assert, flash } = this.context.locals;

    if (submitted) return;

    this.setState({ submitted: true });

    const body = validateWidget(form, false, assert, flash);

    if (body) {
      submit(`/actions/widgets/save`, {
        method: "POST",
        body,
      });
    } else {
      this.setState({ submitted: false });
    }
  }
  ableToSubmit() {
    if (this.state.form.name.length === 0) return false;
    if (this.state.form.description.length === 0) return false;
    if (this.state.form.type.length === 0) return false;
    if (this.state.form.icon.length === 0) return false;
    return true;
  }
  render() {
    const { form } = this.state;
    const { name, description, icon: formIcon, type } = form;
    const { t } = this.props;

    return (
      <form onSubmit={this.handleSubmit}>
        <Modal
          className="Widget-Modal"
          title={t("createWidget.title")}
        >
          <div className="body">
            <div>
              <div className="input-group">
                <label className="label req" htmlFor="name">
                  {t("createWidget.nameLabel")}
                </label>
                <input
                  name="name"
                  type="text"
                  className="text-input"
                  onChange={this.handleChange}
                  value={name}
                  maxLength="30"
                  required
                  placeholder={t("createWidget.namePlaceholder")}
                  sz="large"
                />
              </div>
              <div className="input-group">
                <label className="label req" htmlFor="description">
                  {t("createWidget.descriptionLabel")}
                </label>
                <textarea
                  name="description"
                  type="text"
                  className="text-input"
                  onChange={this.handleChange}
                  value={description}
                  maxLength="60"
                  required
                  placeholder={t("createWidget.descriptionPlaceholder")}
                  sz="large"
                />
              </div>
              <div className="input-group">
                <label>{t("createWidget.typeLabel")}</label>
                <RadioGroupDropdown
                  placeholder={t("createWidget.typePlaceholder")}
                  name="type"
                  currentValue={type}
                  radios={WIDGET_TYPES.map((wt) => ({ ...wt, label: t(`createWidget.widgetType.${wt.value}`) }))}
                  onChange={this.handleChange}
                />
              </div>
              <div className="input-group">
                <ImageRadio
                  label={t("createWidget.iconLabel")}
                  name="icon"
                  currentValue={formIcon}
                  radios={WIDGET_ICONS[type]}
                  onChange={this.handleChange}
                />
              </div>
            </div>
          </div>
          <footer>
            <a
              role="button"
              data-button-type="secondary"
              data-action="cancel"
              href={`/actions/refresh?modal=`}
            >
              {t("common:cancel")}
            </a>
            <button data-button-type="primary" disabled={!this.ableToSubmit()}>
              {t("common:save")}
            </button>
          </footer>
        </Modal>
      </form>
    );
  }
}

CreateWidgetModal.contextType = RillContext;

export default withTranslation(["coaching-portal", "common"])(CreateWidgetModal);
